import { RefSelectProps, Select, SelectProps } from 'antd';
import { forwardRef, ForwardRefRenderFunction } from 'react';
import { useTranslation } from 'react-i18next';
import PageSpinner from '../../../../shared/components/page-spinner/page-spinner';
import { convertServerDateTimeString } from '../../../../shared/utils/format-date/format-date';
import { SignRequest } from '../../models/sign-request';
import { useGetUserSettingsQuery } from '../../../user/api/user-api';
import { UserSettings } from '../../../user/models/user-settings';

type Props = Omit<SelectProps, 'filterOption' | 'showSearch' | 'onSearch' | 'onBlur'>;

interface SignRequestsSelectProps extends Props {
  signRequests: SignRequest[];
  isRequestItemFetching: boolean;
}

const SignRequestsSelect: ForwardRefRenderFunction<RefSelectProps, SignRequestsSelectProps> = (
  { signRequests, isRequestItemFetching, ...props },
  ref,
): JSX.Element => {
  const { t } = useTranslation('common');
  const { data: userSettings } = useGetUserSettingsQuery();

  return (
    <Select
      ref={ref}
      allowClear={true}
      showSearch
      filterOption={(input, option) => (option?.children ?? '').toString().toLowerCase().includes(input.toLowerCase())}
      {...props}
    >
      {isRequestItemFetching ? (
        <PageSpinner />
      ) : (
        (signRequests || []).map(({ id, name, signedAt }) => (
          <Select.Option key={id} value={id}>
            {name || t('label.signRequest')} -{' '}
            {signedAt && convertServerDateTimeString(signedAt, userSettings?.[UserSettings.DateFormat])}
          </Select.Option>
        ))
      )}
    </Select>
  );
};

export default forwardRef(SignRequestsSelect);
